import CardLayout from "components/foundation/templates/CardLayout";
import React from "react";
import styled from "styled-components";
import Divider from "components/foundation/Divider";
import Button from "components/foundation/Button";
import { useNavigate } from "react-router-dom";

export interface DocumentDetailFooterProps {
  fields?: React.ReactNode;
  actions?: React.ReactNode;
}

const DocumentDetailFooter = ({
  fields,
  actions,
}: DocumentDetailFooterProps) => {
  const navigate = useNavigate();

  /**
   * @description 뒤로 버튼 클릭 이벤트 핸들러
   */
  const onClickGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <CardLayoutStyle gap={30}>
        <FieldsStyle>{fields}</FieldsStyle>

        <Divider className="pc-only" />

        <FooterActionsStyle className={!actions ? "pc-only" : undefined}>
          <Button
            variant="tertiary"
            size="large"
            onClick={onClickGoBack}
            className="pc-only"
          >
            뒤로
          </Button>

          {actions && (
            <FooterRightActionsStyle>{actions}</FooterRightActionsStyle>
          )}
        </FooterActionsStyle>
      </CardLayoutStyle>
    </>
  );
};

export default DocumentDetailFooter;

/* 스타일 */
const CardLayoutStyle = styled(CardLayout.Container)`
  ${({ theme }) => theme.media.small} {
    padding: 0 1.6rem;
  }
`;

const FieldsStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const FooterActionsStyle = styled.div`
  display: flex;
  justify-content: space-between;

  ${({ theme }) => theme.media.notSmall} {
    button {
      width: 20rem;
    }
  }

  ${({ theme }) => theme.media.small} {
    padding-top: 2rem;
    button {
      flex: 1;
    }
  }
`;

const FooterRightActionsStyle = styled.div`
  display: inline-flex;
  gap: 1rem;

  ${({ theme }) => theme.media.small} {
    width: 100%;
  }
`;
